module.exports = __webpack_public_path__ + "img/approved.d8aac964.svg";